

// src/components/Sidebar.js
// src/components/Sidebar.js
// src/components/Sidebar.js
import React from 'react';
import './Sidebar.css';

function Sidebar({ onPageChange, isOpen }) {
  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
      <ul className="menu">
        <li onClick={() => onPageChange('Dashboard')}>Dashboard</li>
        <li onClick={() => onPageChange('Orders')}>Orders</li>
        <li onClick={() => onPageChange('Deliveriessec')}>Deliveries</li>
        {/* <li onClick={() => onPageChange('Deliveries')}>Deliveries</li> */}
        <li onClick={() => onPageChange('Team')}>Team</li>
      </ul>
    </aside>
  );
}

export default Sidebar;



// // src/components/Sidebar.js
// import React from 'react';
// import './Sidebar.css';

// function Sidebar() {
//   return (
//     <div className="sidebar" role="complementary">
//       <div className="logo">UAB <br /> Professional Studies</div>
//       <ul className="menu">
//         <li>Dashboard</li>
//         <li>Courses</li>
//         <li>Calendar</li>
//         <li>Inbox</li>
//         <li>History</li>
//         <li>My Media</li>
//         <li>Help</li>
//       </ul>
//     </div>
//   );
// }

// export default Sidebar;
